




























































































































































import Vue from 'vue';
import VueCompositionAPI, {defineComponent, ref, computed} from '@vue/composition-api';
import {VPopover, VClosePopover} from 'v-tooltip';
import {formatPrices} from './utils';
import ExtLinkIcon from '@components/svg/external-link.vue';
import Loader from '@common/circular-loader.vue';
import HeartIcon from '@components/svg/heart.vue';
import FilledHeartIcon from '@components/svg/filled-heart.vue';
import CalendarIcon from '@components/svg/calendar.vue';

Vue.use(VueCompositionAPI);

import RadioInput from './radio-input.vue';
import SchedulePopover from './schedule-popover.vue';
import {POIDetailsProps, Timeslot, PoiItem, LunchTime, AddEvent} from './types';
import {useMealToggle} from './meal-toggle';

import DetailsBody from './solution-item-details-body.vue';
import { AdditionalPoisModule } from '@/store/modules';
import POIRelations from '@components/common-components/card/poi-relations.vue';

const ACCOMMODATION = 'ACCOMMODATION';
const EXPERIENCE = 'EXPERIENCE';
const DINING = 'DINING';

const AmexAdditionalActivitiesList = defineComponent({
  components: {
    RadioInput,
    SchedulePopover,
    VPopover,
    DetailsBody,
    HeartIcon,
    FilledHeartIcon,
    CalendarIcon,
    ExtLinkIcon,
    Loader,
    POIRelations,
  },
  directives: {
    'close-popover': VClosePopover,
  },
  props: {
    selectedPoi: Object,
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSchedulled: {
      type: Boolean,
      default: false,
    },
    isMapViewAvailable: {
      type: Boolean,
      default: false,
    },
    alternatives: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRemoveAllowed: {
      type: Boolean,
      default: true,
    },
    isAddAllowed: {
      type: Boolean,
      default: false,
    },
    selectedDayLabel: {
      type: String,
      default: '',
    },
    contextName: {
      type: String,
      default: '',
    },
    selectedDayDetails: {
      type: String,
      default: '',
    },
    availableDates: {
      type: Array,
      default: () => [],
    },
    getAvailableTimeSlots: {
      type: Function,
      default: () => () => Promise.resolve([]),
    },
    rooms: {
      type: Array,
      default: () => [],
    },
    savedPoiIds: {
      type: Set,
      default: () => new Set(),
    },
  },
  setup(props: POIDetailsProps, {emit}) {
    const pendingActivity = ref<PoiItem | null>(null);
    const isTimeSlotsPending = ref<boolean>(true);
    const availableTimeSlots = ref<Timeslot[]>([]);

    const onShowDetailsEmit = (alternativeId: string) => {
      emit('show-details', alternativeId);
    };

    const onAddEmit = (evt: AddEvent) => {
      emit('add', evt);
    };

    const url = computed(() => {
      return props.selectedPoi.url || '';
    });
    const name = computed(() => {
      return props.selectedPoi?.name || '';
    });

    const type = computed(() => {
      return props?.selectedPoi?.types?.join(' & ') || '';
    });

    const category = computed(() => {
      const categories = props.selectedPoi?.categories || [];
      return categories.length ? categories[0] : EXPERIENCE;
    });

    const usd = computed(() => {
      return formatPrices(props.selectedPoi?.prices || [])?.labels['USD'] || '';
    });
    const price = computed(() => {
      const level = props.selectedPoi?.price_level?.upperbound || 0;
      if (category.value === DINING && level) {
        return new Array(level).fill('$').join('');
      }
      return usd.value;
    });
    const isStay = computed(() => {
      return category.value === ACCOMMODATION;
    });

    const {getSelectedLunchTime, onMealChange, ...mealProps} = useMealToggle(category);

    const onAddBtnClick = (event?: Event) => {
      // if (category.value === ACCOMMODATION) {
      emit('add', {lunchTime: LunchTime.NONE, poiId: props.selectedPoi.id});
      event?.stopPropagation();
      // return;
      // }

      // pendingActivity.value = {...props.selectedPoi};

      // openRescheduleOptions();
    };

    const onCloseScheduler = () => {
      pendingActivity.value = null;
    };

    const openRescheduleOptions = async () => {
      if (pendingActivity.value) {
        onCloseScheduler();
        return;
      }
      pendingActivity.value = {...props.selectedPoi};
      onMealChange(LunchTime.ANY);
      isTimeSlotsPending.value = true;
      availableTimeSlots.value = [];
      try {
        const getTimeSlots = props.getAvailableTimeSlots || (() => Promise.resolve([]));
        const timeslots = await getTimeSlots();
        availableTimeSlots.value = timeslots;
      } catch {
        availableTimeSlots.value = [];
      }
      isTimeSlotsPending.value = false;
    };

    const onRescheduleClick = ({timeslot}: {timeslot: Timeslot | null}) => {
      emit('reschedule', {
        timeslot: timeslot,
        lunchTime: getSelectedLunchTime(),
      });
    };

    const onItemRemove = (id: string) => {
      emit('remove', id);
    };

    const rating = computed(() => {
      return (props.selectedPoi?.rating || 0).toFixed(1);
    });

    const address = computed(() => {
      return props.selectedPoi?.location?.address || '';
    });

    const childPois = computed(() => {
      return (props.selectedPoi?.children || []).map((child) => AdditionalPoisModule.getPoiById(child));
    });

    const parentPoi = computed(() => {
      return AdditionalPoisModule.getPoiById(props.selectedPoi?.parent || '');
    });

    const allPois = computed(() => {
      return [parentPoi.value, ...childPois.value].filter(Boolean)
      .map((x) => ({
        img: x?.images?.small,
        name: x?.name,
        id: x?.id,
      }))
      .filter((x) => x.id !== props.selectedPoi?.id);
    });

    return {
      name,
      type,
      category,
      price,
      rating,
      address,
      url,
      // priceLabel,
      isStay,
      onAddBtnClick,
      onRescheduleClick,
      pendingActivity,
      onItemRemove,
      ...mealProps,
      isTimeSlotsPending,
      availableTimeSlots,
      onShowDetailsEmit,
      onAddEmit,
      getSelectedLunchTime,
      onMealChange,
      onCloseScheduler,
      openRescheduleOptions,
      childPois,
      parentPoi,
      allPois,
    };
  },
});

export default AmexAdditionalActivitiesList;
